import React, { memo } from 'react';
import { BookIcon } from 'lucide-react';
const tomos = [{
  number: 1,
  title: 'VOCABULARIO 3000',
  description: 'Las 3.000 palabras más usadas en inglés con significado y uso práctico. Para construir base real y hablar desde el día 1.'
}, {
  number: 2,
  title: 'EXPRESIONES PARA UN INGLÉS FLUIDO',
  description: 'Las expresiones más usadas en conversaciones reales para sonar natural. Incluye práctica y mini diálogos.'
}, {
  number: 3,
  title: 'APRENDE INGLÉS CANTANDO (CANCIONERO)',
  description: 'Aprende con canciones (sin letras) usando frases clave, vocabulario y expresiones inspiradas en pop. Ideal para memorizar sin esfuerzo.'
}, {
  number: 4,
  title: 'GUÍA DE EXPRESIONES COMUNES + GRAMÁTICA FÁCIL PARA ADULTOS',
  description: 'De principiante a intermedio/avanzado con patrones claros. Método de repetición inteligente y sustitución para aprender sin memorizar reglas.'
}, {
  number: 5,
  title: 'HISTORIAS CORTAS PARA REFORZAR',
  description: '10 historias (A1–B1) con resumen en español, vocabulario clave y ejercicios. Para mejorar reading + vocabulario en contexto.'
}];
export function WhatIncludes() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-176">
          MEGAPACK "INGLÉS EN ACCIÓN" (5 TOMOS)
        </h2>

        <div className="space-y-3" data-id="element-177">
          {tomos.map(tomo => <div key={tomo.number} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-178">
              <div className="flex items-start gap-4" data-id="element-179">
                <div className="flex-shrink-0 w-12 h-12 bg-[#FF6B00] text-white rounded-lg flex items-center justify-center" data-id="element-180">
                  <BookIcon className="w-6 h-6" data-id="element-181" />
                </div>
                <div data-id="element-182">
                  <h3 className="text-lg font-bold text-[#1A1A2E] mb-1" data-id="element-183">
                    TOMO {tomo.number} — {tomo.title}
                  </h3>
                  <p className="text-[#4A4A5A]" data-id="element-184">{tomo.description}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}